import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "INVOICE_PICKING_" }
);

export interface InvoicePickingState extends IState {}

const INITIAL_STATE: InvoicePickingState = {
  loading: false,
  error: null,
};

const request = (state: InvoicePickingState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: InvoicePickingState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: InvoicePickingState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const invoicePicking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const InvoicePickingTypes = Types;
export const InvoicePickingActions = Creators;
